/**
 * Order Approval Handler - manages the order approval functionality
 */
class OrderApprovalHandler {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            // Handle approve button clicks
            document.querySelectorAll('.approve-order').forEach(button => {
                button.addEventListener('click', () => {
                    const orderId = button.getAttribute('data-order-id');
                    this.approveOrder(orderId, button);
                });
            });
            
            // Handle reject button clicks
            document.querySelectorAll('.reject-order').forEach(function(button) {
                button.addEventListener('click', () => {
                    const orderId = button.getAttribute('data-order-id');
                    this.rejectOrder(orderId, button);
                });
            });
        });
    }

    approveOrder(orderId, button) {
        if (confirm(window._litiumTranslations['orderlist.confirmapprove'] || 'Are you sure you want to approve this order?')) {
            const row = button.closest('.order-row');
            fetch(`/api/orderapproval/approve/${orderId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Remove the row
                    row.remove();
                    
                    // Update counts and check if we need to show the 'no orders' message
                    this.updateOrdersCounts();
                    
                    // Show success message
                    alert(window._litiumTranslations['orderlist.approvedsuccess'] || 'Order approved successfully');
                } else {
                    alert(data.message || window._litiumTranslations['orderlist.approvedfailed'] || 'Failed to approve order');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert(window._litiumTranslations['orderlist.approvedfailed'] || 'Failed to approve order');
            });
        }
    }

    rejectOrder(orderId, button) {
        if (confirm(window._litiumTranslations['orderlist.confirmreject'] || 'Are you sure you want to reject this order?')) {
            const row = button.closest('.order-row');
            fetch(`/api/orderapproval/reject/${orderId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Remove the row
                    row.remove();
                    
                    // Update counts and check if we need to show the 'no orders' message
                    this.updateOrdersCounts();
                    
                    // Show success message
                    alert(window._litiumTranslations['orderlist.rejectedsuccess'] || 'Order rejected successfully');
                } else {
                    alert(data.message || window._litiumTranslations['orderlist.rejectedfailed'] || 'Failed to reject order');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert(window._litiumTranslations['orderlist.rejectedfailed'] || 'Failed to reject order');
            });
        }
    }

    updateOrdersCounts() {
        const remainingOrders = document.querySelectorAll('.order-row').length;
        
        // If no orders left, show the 'no orders' message
        if (remainingOrders === 0) {
            const ordersList = document.querySelector('.orders-to-approve__list');
            ordersList.innerHTML = `<div class="no-orders-message">${window._litiumTranslations['code.orderlist.noapprovalsfound'] || 'No orders waiting for approval'}</div>`;
            
            // Hide the badge
            const badge = document.querySelector('.notification-badge');
            if (badge) {
                badge.style.display = 'none';
            }
        } else {
            // Update the badge count
            const badge = document.querySelector('.notification-badge');
            if (badge) {
                badge.textContent = remainingOrders.toString();
            }
        }
    }
}

// Initialize the order approval handler when the script is loaded
export default new OrderApprovalHandler();
